(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-bra-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-veloura-guide-calculator]').forEach((guide) => {
      const dataNode = guide.querySelector('[data-veloura-fit-data]');
      const form = guide.querySelector('[data-guide-calc-form]');
      const result = guide.querySelector('[data-guide-calc-result]');
      const message = guide.querySelector('[data-guide-calc-message]');
      if (!dataNode || !form || !result || !message) return;
      let fitData = { bands: [], cups: [] };
      try { fitData = JSON.parse(dataNode.textContent || '{}'); } catch (error) { return; }
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const under = Number(form.elements.underbust.value);
        const over = Number(form.elements.overbust.value);
        result.hidden = true;
        message.textContent = '';
        if (!Number.isFinite(under) || !Number.isFinite(over) || under <= 0 || over <= 0 || over <= under) { message.textContent = 'Please enter valid measurements, with bust larger than band.'; return; }
        const band = fitData.bands.find((row) => { const bounds = row.range.split('-').map(Number); return under >= bounds[0] && under <= bounds[1]; });
        const difference = Math.round(over - under);
        const cup = fitData.cups.find((row) => { const bounds = row.range.split('-').map(Number); return difference >= bounds[0] && difference <= bounds[1]; });
        if (!band || !cup) { message.textContent = 'These measurements are outside our current guide. Please check the chart or contact VELOURA for personal help.'; return; }
        const ukSize = `${band.band}${cup.cup}`;
        guide.querySelector('[data-guide-calc-uk]').textContent = ukSize;
        guide.querySelector('[data-guide-calc-int]').textContent = `${band.international}${cup.cup}`;
        guide.querySelector('[data-guide-calc-us]').textContent = ukSize;
        guide.querySelector('[data-guide-calc-fr]').textContent = `${band.international + 15}${cup.cup}`;
        result.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-fit-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-veloura-guide-hub]').forEach((guide) => {
      const dataNode = guide.querySelector('[data-veloura-fit-data]');
      const under = guide.querySelector('[data-hub-under]');
      const over = guide.querySelector('[data-hub-over]');
      const result = guide.querySelector('[data-hub-result]');
      if (!dataNode || !under || !over || !result) return;
      let rows = [];
      try { rows = JSON.parse(dataNode.textContent || '[]'); } catch (error) { return; }
      const reset = () => { result.hidden = true; };
      under.addEventListener('change', () => {
        const matches = rows.filter((row) => row.underRange === under.value);
        over.innerHTML = '<option value="">Select your overbust</option>';
        matches.forEach((row) => { const option = document.createElement('option'); option.value = row.overCm; option.textContent = `${row.overCm} cm`; over.appendChild(option); });
        over.disabled = matches.length === 0; reset();
      });
      over.addEventListener('change', () => {
        const match = rows.find((row) => row.underRange === under.value && String(row.overCm) === over.value);
        if (!match) { reset(); return; }
        guide.querySelector('[data-hub-uk]').textContent = match.uk;
        guide.querySelector('[data-hub-int]').textContent = match.international;
        guide.querySelector('[data-hub-us]').textContent = match.us;
        result.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-veloura-product]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const variants = JSON.parse(root.querySelector('[data-product-variants]').textContent);
      const idInput = root.querySelector('[data-variant-id]');
      const addButtons = root.querySelectorAll('[data-add-to-cart], [data-sticky-add]');
      const price = root.querySelector('[data-product-price]');
      const compare = root.querySelector('[data-product-compare-price]');
      const stickyPrice = root.querySelector('[data-sticky-price]');
      const money = (cents) => new Intl.NumberFormat('en-PK', { style: 'currency', currency: 'PKR', maximumFractionDigits: 0 }).format(cents / 100);
      const chosen = () => Array.from(root.querySelectorAll('.vp-option')).map((group) => group.querySelector('input:checked')?.value);
      const update = () => {
        const options = chosen();
        const variant = variants.find((item) => item.options.every((value, index) => value === options[index])) || variants[0];
        if (!variant) return;
        idInput.value = variant.id;
        price.textContent = money(variant.price);
        stickyPrice.textContent = money(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.hidden = false;
          compare.textContent = money(variant.compare_at_price);
        } else compare.hidden = true;
        addButtons.forEach((button) => {
          button.disabled = !variant.available;
          const label = button.querySelector('span');
          if (label) label.textContent = variant.available ? (root.querySelector('[data-add-to-cart]')?.dataset.addLabel || 'Add to cart') : (root.querySelector('[data-add-to-cart]')?.dataset.soldLabel || 'Sold out');
        });
        root.querySelectorAll('.vp-option').forEach((group, groupIndex) => {
          group.querySelectorAll('input').forEach((input) => {
            input.disabled = !variants.some((item) => item.available && item.options.every((value, index) => index === groupIndex ? value === input.value : value === options[index]));
          });
          const label = group.querySelector('[data-option-label]');
          if (label) label.textContent = group.querySelector('input:checked')?.value || '';
        });
        if (variant.featured_media) root.querySelector(`[data-gallery-thumb="${variant.featured_media.id}"]`)?.click();
      };
      root.querySelectorAll('[data-option-index]').forEach((input) => input.addEventListener('change', update));
      update();

      const quantity = root.querySelector('[data-quantity-input]');
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });

      const gallery = root.querySelector('[data-product-gallery]');
      const slides = Array.from(root.querySelectorAll('[data-product-media]'));
      const setActive = (slide) => {
        root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
          const active = thumb.dataset.galleryThumb === slide?.dataset.productMedia;
          thumb.classList.toggle('is-active', active);
          if (active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
        });
      };
      root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
        const slide = root.querySelector(`[data-product-media="${thumb.dataset.galleryThumb}"]`);
        slide?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
        setActive(slide);
      }));
      root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => gallery.scrollBy({ left: -gallery.clientWidth, behavior: 'smooth' }));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => gallery.scrollBy({ left: gallery.clientWidth, behavior: 'smooth' }));

      const dialog = root.querySelector('[data-size-guide-dialog]');
      root.querySelectorAll('[data-size-guide-open]').forEach((button) => button.addEventListener('click', () => dialog.showModal()));
      root.querySelector('[data-size-guide-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

      const mainAdd = root.querySelector('[data-add-to-cart]');
      mainAdd?.closest('form')?.addEventListener('submit', () => {
        const label = mainAdd.querySelector('span');
        if (label) label.textContent = mainAdd.dataset.loadingLabel;
        mainAdd.setAttribute('aria-busy', 'true');
      });

      try {
        const current = JSON.parse(root.querySelector('[data-recent-product]').textContent);
        const stored = JSON.parse(localStorage.getItem('velouraRecentlyViewed') || '[]').filter((item) => item.url !== current.url).slice(0, 4);
        const recent = root.querySelector('[data-recently-viewed]');
        const grid = root.querySelector('[data-recent-grid]');
        const escape = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[character]));
        if (stored.length) {
          grid.innerHTML = stored.map((item) => `<a class="vp-card" href="${escape(item.url)}">${item.image ? `<img src="${escape(item.image)}" loading="lazy" alt="${escape(item.title)}">` : ''}<span>${escape(item.title)}</span><strong>${money(item.price)}</strong></a>`).join('');
          recent.hidden = false;
        }
        localStorage.setItem('velouraRecentlyViewed', JSON.stringify([current, ...stored].slice(0, 5)));
      } catch (error) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-size-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-veloura-calculator]').forEach((guide) => {
      const dataNode = guide.querySelector('[data-veloura-fit-data]');
      const form = guide.querySelector('[data-calc-form]');
      const result = guide.querySelector('[data-calc-result]');
      const message = guide.querySelector('[data-calc-message]');
      if (!dataNode || !form || !result || !message) return;
      let fitData = { bands: [], cups: [] };
      try { fitData = JSON.parse(dataNode.textContent || '{}'); } catch (error) { return; }
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const under = Number(form.elements.underbust.value);
        const over = Number(form.elements.overbust.value);
        result.hidden = true;
        message.textContent = '';
        if (!Number.isFinite(under) || !Number.isFinite(over) || under <= 0 || over <= 0 || over <= under) { message.textContent = 'Please enter valid measurements, with bust larger than band.'; return; }
        const band = fitData.bands.find((row) => { const bounds = row.range.split('-').map(Number); return under >= bounds[0] && under <= bounds[1]; });
        const difference = Math.round(over - under);
        const cup = fitData.cups.find((row) => { const bounds = row.range.split('-').map(Number); return difference >= bounds[0] && difference <= bounds[1]; });
        if (!band || !cup) { message.textContent = 'These measurements are outside our current guide. Please review the Bra Size Guide or contact us.'; return; }
        const ukSize = `${band.band}${cup.cup}`;
        guide.querySelector('[data-calc-uk]').textContent = ukSize;
        guide.querySelector('[data-calc-int]').textContent = `${band.international}${cup.cup}`;
        guide.querySelector('[data-calc-us]').textContent = ukSize;
        guide.querySelector('[data-calc-fr]').textContent = `${band.international + 15}${cup.cup}`;
        result.hidden = false;
        result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rows = [
      ['26-27','32','32AA','32A','85A','70A'],['26-27','33','32A','32B','85B','70B'],['26-27','34','32B','32C','85C','70C'],['26-27','35','32C','32D','85D','70D'],['26-27','36','32D','32DD','85DD','70DD'],
      ['28-29','34','34AA','34A','90A','75A'],['28-29','35','34A','34B','90B','75B'],['28-29','36','34B','34C','90C','75C'],['28-29','37','34C','34D','90D','75D'],['28-29','38','34D','34DD','90DD','75DD'],['28-29','39','34DD','34E','90E','75E'],
      ['30-31','36','36AA','36A','95A','80A'],['30-31','37','36A','36B','95B','80B'],['30-31','38','36B','36C','95C','80C'],['30-31','39','36C','36D','95D','80D'],['30-31','40','36D','36DD','95DD','80DD'],['30-31','41','36DD','36E','95E','80E'],
      ['32-33','38','38AA','38A','100A','85A'],['32-33','39','38A','38B','100B','85B'],['32-33','40','38B','38C','100C','85C'],['32-33','41','38C','38D','100D','85D'],['32-33','42','38D','38DD','100DD','85DD'],['32-33','43','38DD','38E','100E','85E']
    ];
    document.querySelectorAll('[data-veloura-fit-guide]').forEach((guide) => {
      const under = guide.querySelector('[data-fit-underbust]');
      const over = guide.querySelector('[data-fit-overbust]');
      const result = guide.querySelector('[data-fit-result]');
      if (!under || !over || !result) return;
      const resetResult = () => { result.hidden = true; };
      under.addEventListener('change', () => {
        const matches = rows.filter((row) => row[0] === under.value);
        over.innerHTML = '';
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = guide.dataset.overbustPlaceholder;
        over.appendChild(placeholder);
        matches.forEach((row) => {
          const option = document.createElement('option'); option.value = row[1]; option.textContent = `${row[1]} in`; over.appendChild(option);
        });
        over.disabled = matches.length === 0; over.value = ''; resetResult();
      });
      over.addEventListener('change', () => {
        const match = rows.find((row) => row[0] === under.value && row[1] === over.value);
        if (!match) { resetResult(); return; }
        guide.querySelector('[data-fit-primary]').textContent = match[3];
        guide.querySelector('[data-fit-us]').textContent = match[2];
        guide.querySelector('[data-fit-english]').textContent = match[3];
        guide.querySelector('[data-fit-french]').textContent = match[4];
        guide.querySelector('[data-fit-international]').textContent = match[5];
        result.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
